import React, { useMemo } from 'react';
import { Timeline, Typography } from 'antd';
import { FileTextOutlined, CheckCircleOutlined, DollarOutlined, CreditCardOutlined } from '@ant-design/icons';
import dayjs from '../dayjs';

const { Text } = Typography;

const DocumentHistory = ({ charter }) => {
  const history = useMemo(() => {
    return charter.quoteHistory.sort((a, b) => b.timestamp - a.timestamp);
  }, [charter]);

  const getIcon = (type) => {
    switch (type) {
      case 'quote':
        return <FileTextOutlined style={{ color: '#1890ff' }} />;
      case 'confirmation':
        return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
      case 'invoice':
        return <DollarOutlined style={{ color: '#722ed1' }} />;
      case 'receipt':
        return <CreditCardOutlined style={{ color: '#13c2c2' }} />;
      default:
        return <FileTextOutlined />;
    }
  };

  if (history.length === 0) return null;

  return (
    <Timeline
      style={{ marginTop: 24 }}
      items={history.map(item => ({
        dot: getIcon(item.type),
        children: (
          <>
            <Text strong>{item.label} by {item.user}</Text>
            <br />
            <Text type="secondary">{item.date}</Text>
          </>
        )
      }))}
    />
  );
};

export default DocumentHistory; 